import { useParams, useOutletContext, Link } from "react-router-dom";
import { useEffect, useState } from 'react';

import './Biokem.css';
import { translations } from './../../../i18/translations.js';
import RomanConverter from "./RomanConverter";
import YearList from "./YearList";
import BiokemSearch from "./BiokemSearch";
import ContentDiv from "./../ContentDiv";

const Biokem = () => {
    const API_URL = process.env.REACT_APP_SERVICE_API_URL;
    const RESOURCES_DIR = process.env.REACT_APP_RESOURCES_DIR;

    const {year} = useParams();
    const {lang} = useOutletContext();

    const toYear = (y) => (y && Number(y) !== -1 ? Number(y) : new Date().getFullYear());

    const convertTo = (y) => RomanConverter.convert(toYear(y) - 1977 + 1);

    const [yearData, setYearData] = useState({year: -1, journals: [], prev: -1, next: -1});
    const [rNum, setRNum] = useState("");

    const fetchYearData = async (selectedYear) => {
        try {
            const response = await fetch(`${API_URL}/common/get_biokem_list.php`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({year: toYear(selectedYear)})
            });
            const data = await response.json();
            setYearData(data);
        } catch (error) {
            console.error('Error fetching journals:', error);
        }
    };

    useEffect(() => {
        fetchYearData(year);
    }, [year]);

    useEffect(() => {
        setRNum(convertTo(yearData.year));
    }, [yearData.year]);

    return (
            <div className="mbkegy-content">
            
                <ContentDiv contentId={12008} lang={lang} showTitle={false} />
            
                <BiokemSearch />
            
                <p className="link-row">
                    <a className="content-view-link" download href={`${RESOURCES_DIR}/content/docs/main/biokemf_utmutato/utmutato2.pdf`} target="_blank" rel="noopener noreferrer">
                        {translations[lang].mbkegy_guide} (.pdf)
                    </a>
                    <a className="content-view-link" download href={`${RESOURCES_DIR}/content/docs/main/biokemf_utmutato/utmutato2.docx`} target="_blank" rel="noopener noreferrer">(.docx)</a>
                    &nbsp;&nbsp;|&nbsp;&nbsp;
                    <a className="content-view-link" download href={`${RESOURCES_DIR}/content/docs/main/endnotetemplate/endnote_templat.ens`} target="_blank" rel="noopener noreferrer">
                        {translations[lang].mbkegy_ens}
                    </a>
                </p>
            
                <YearList onChangeYear={(newYear) => fetchYearData(newYear)} />
            
                <span className="content-item-title">
                    {translations[lang].mbkegy_volume.replace("{n}", rNum)}
                </span>
            
                <h2 className="mbkegy-content">- {yearData.year} -</h2>
            
                <div className="image-gallery">
                    {yearData.prev !== -1 && (
                            <Link to={`/Biokem/${yearData.prev}`} className="biokem-pager" onClick={() => fetchYearData(yearData.prev)}>◁</Link>
                                )}
            
                    <div className="image-item-list">
                        {yearData.journals.map((item) => (
                                <div className="image-item" key={item.index}>
                                    <Link to={`/BiokemShow/${yearData.year}/${item.index}/${item.title}`} className="journal-link">
                                    <img src={`${RESOURCES_DIR}/biokem/${yearData.year}/${item.jpg}`} alt={item.title} />
                                    <p>{translations[lang][item.title] || item.title}</p>
                                    </Link>
                                </div>
                                        ))}
                    </div>
            
                    {yearData.next !== -1 && (
                            <Link to={`/Biokem/${yearData.next}`} className="biokem-pager" onClick={() => fetchYearData(yearData.next)}>▷</Link>
                                )}
                </div>
            
                <div className="biokemia-footer">
                    <img src="../../../assets/img/main/biokemia_footer.png" alt="Logo" />
                </div>
            
            </div>
            );
};

export default Biokem;
